import {
  CalendarText,
  ExportButtonandSettingIconPhone,
  ExportDataButton,
  ExportIcon,
} from "../../pages/DashboardReturningUsers/DashboardReturningUsers.styles";
import { export_icon } from "../../../public/assets";
import { IoSettingsOutline } from "react-icons/io5";
import React from "react";

type ExportButtonProps = React.PropsWithChildren<{
  onClick?: () => void;
  text?: string;
}>;
export const ExportButton: React.FC<ExportButtonProps> = ({
  onClick,
  text,
  children,
}) => {
  return (
    <ExportButtonandSettingIconPhone onClick={onClick}>
      <ExportDataButton>
        <ExportIcon src="/assets/icons/export_icon.png" />
        <CalendarText>{text || "Export Data"}</CalendarText>
      </ExportDataButton>
      {children}
    </ExportButtonandSettingIconPhone>
  );
};
